export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

/** Форма тела ошибки, которую отдаёт бэкенд: `{ error: { code, message, details } }` */
export type ApiErrorBody = {
  error: {
    code?: string
    message?: string
    details?: unknown
  }
}

export function isApiErrorBody(value: unknown): value is ApiErrorBody {
  if (typeof value !== 'object' || value === null) return false
  const errorField = (value as Record<string, unknown>).error
  return typeof errorField === 'object' && errorField !== null
}
